import React from 'react';
import { StyleSheet } from 'react-native';

import { FadeView, theme } from '@sg/garnish';

import { Home } from '@order/features-home';
import { useFeatureFlag } from '@order/LaunchDarkly';

import { useHomeBannerInfo } from '../../hooks';

export const HomeScreenBanner = () => {
  const bannerInfo = useHomeBannerInfo();
  const isNavbarV2Enabled = useFeatureFlag('CELS-5440-order-navbar-v2-enabled');

  return (
    <FadeView duration={500} style={styles.fadeViewElevation} show={Boolean(bannerInfo)}>
      {bannerInfo ? <Home.Banner {...bannerInfo} isInsetXS={isNavbarV2Enabled} /> : null}
    </FadeView>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  fadeViewElevation: {
    zIndex: theme.zIndex.fixed,
  },
});
